import React, { useEffect, useState } from 'react'
import './NumericalTypeAnswer.css'
import backspace from '../../assets/backspace.svg'
import CorrectAnswer from '../../assets/correct_answer.svg'
import WrongAnswer from '../../assets/wrong_answer.svg'
import InstructionsModal from '../InstructionsModal/InstructionsModal'
import information from '../../assets/information-1.png'
const NumericalTypeAnswer = (props) => {
    const [value, setValue] = useState(props.data.question.answerbyUser[0])
    const [show, setShow] = useState(false)
    const handleModal = () => {
        setShow(!show)
    }
    useEffect(() => {
        if (props.data.question.answerbyUser == '') {
            setValue('')
        }
        // console.log("----document----",document)
        // let d = document.getElementById('numeric')
        //  document.addEventListener('keyup', (event)=> {

        //     let numbers = ['1','2','3','4','5','6','7','8','9','0']
        //     if(numbers.includes(event.key)){
        //         console.log("---add-",(event.key))
        //         handleValue(event.key)
        //     }

        //     });
    }, [props.data.question.answerbyUser])

    const handleValue = (v) => {
        let temp = value.split('')
        if (props.type === 'SAN') {
            if (v === '.') {
                if (temp.includes('.')) {
                    return
                }
            }
            if (v === '-') {
                if (value === '') {
                    let currentValue = value
                    currentValue = currentValue + v
                    setValue(currentValue)
                    props.onClick(currentValue, props.data)
                    return
                } else {
                    alert('You can only use it at starting of the value')
                    return
                }
            }
            let index = temp.indexOf('.')
            if (temp.includes('.') && temp.length - index > 2) {
                return
            } else {
                let currentValue = value
                currentValue = currentValue + v
                setValue(currentValue)
                props.onClick(currentValue, props.data)
            }
        }
        if (props.type === 'SAT') {
            if (v === '-') {
                if (value === '') {
                    let currentValue = value
                    currentValue = currentValue + v
                    setValue(currentValue)
                    props.onClick(currentValue, props.data)
                    return
                } else {
                    alert('You can only use it at starting of the value')
                    return
                }
            }
            if (v !== '.') {
                if (temp.length < 1) {
                    let currentValue = value
                    currentValue = currentValue + v
                    setValue(currentValue)
                    props.onClick(currentValue, props.data)
                    return
                }
                if (temp.length < 2 && temp.includes('-')) {
                    let currentValue = value
                    currentValue = currentValue + v
                    setValue(currentValue)
                    props.onClick(currentValue, props.data)
                }
            }
        }
    }
    const handleKeyboardValues = (e) => {
        let vl = e.target.value
        let inp = vl.split('')
        let v = inp[inp.length - 1]
        let spl = inp.slice(0, inp.length - 1)

        if (
            Number.isInteger(parseInt(v)) ||
            v === undefined ||
            v === '-' ||
            v === '.'
        ) {
            let temp = spl
            if (props.type === 'SAN') {
                if (v === '.') {
                    if (temp.includes('.')) {
                        return
                    }
                }
                if (v === '-') {
                    if (spl === '') {
                        setValue(vl)
                        props.onClick(vl, props.data)
                        return
                    } else if (temp.length > 0) {
                        alert('You can only use it at starting of the value')
                        return
                    } else if (temp.includes('-')) {
                        alert('You can only use it at starting of the value')
                        return
                    }
                }
                let index = temp.indexOf('.')
                if (temp.includes('.') && temp.length - index > 2) {
                    return
                } else {
                    setValue(vl)
                    props.onClick(vl, props.data)
                }
            }
            if (props.type === 'SAT') {
                if (v === '-') {
                    if (spl === '') {
                        setValue(vl)
                        props.onClick(vl, props.data)
                        return
                    } else if (temp.length > 0) {
                        alert('You can only use it at starting of the value')
                        return
                    } else if (temp.includes('-')) {
                        alert('You can only use it at starting of the value')
                        return
                    }
                }
                if (v == '.') {
                    if (temp.length === 0) {
                        setValue(vl)
                        props.onClick(vl, props.data)
                        return
                    }
                    if (temp.length === 1 && temp.includes('-')) {
                        setValue(vl)
                        props.onClick(vl, props.data)
                        return
                    }
                } else {
                    if (temp.length === 0) {
                        setValue(vl)
                        props.onClick(vl, props.data)
                        return
                    }
                    if (temp.length === 1 && temp.includes('-')) {
                        setValue(vl)
                        props.onClick(vl, props.data)
                    }
                    if (temp.length === 1 && temp.includes('.')) {
                        setValue(vl)
                        props.onClick(vl, props.data)
                    }
                    if (
                        temp.length === 2 &&
                        temp.includes('-') &&
                        temp.includes('.')
                    ) {
                        setValue(vl)
                        props.onClick(vl, props.data)
                    }
                }
            }
        }
    }
    const handleClear = () => {
        setValue('')
        props.onClick('', props.data)
    }
    const handleBackSpace = () => {
        let currentValue = value
        currentValue = currentValue.substring(0, currentValue.length - 1)
        setValue(currentValue)
        props.onClick(currentValue, props.data)
    }
    const handleStyle = () => {
        if (value !== '') {
            // if(props.mock){
            //     if(value==props.data.question.answers.answer)
            //         return 'display conatains_mock_crt'
            //     else
            //         return 'display conatains_mock_wrg'
            // }
            return 'display conatains'
        }
        return 'display'
    }

    let d = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '-', '.']

    return (
        <div className="numerical" id="numeric">
            <div className="dialpad">
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <span className="ans-description">
                        Round of answer to 2 decimal places
                    </span>
                    {props.mock ? (
                        <span className="difficulty-level">
                            {props.data.question.lod == 'E'
                                ? 'Easy'
                                : props.data.question.lod == 'M'
                                ? 'Medium'
                                : 'Difficult'}
                        </span>
                    ) : null}
                    {!props.mock && (
                        <span style={{ marginBottom: '14px', marginTop: '45px' }}>
                            <img
                                src={information}
                                onClick={handleModal}
                                style={{
                                    height: '17px',
                                    width: '17px',
                                    cursor: 'pointer',
                                }}
                            />
                        </span>
                    )}
                </div>
                {/*{props.mock && value==props.data.question.answers.answer ? <><img style={{marginRight:'5px'}} src={CorrectAnswer}/><span style={{color:'#2dce89',fontSize:'15px',fontWeight:'bold'}}>Correct Answer</span> </>:null}*/}
                {/*{props.mock && value!=props.data.question.answers.answer ? <><img style={{marginRight:'5px'}} src={WrongAnswer}/><span style={{color:'#f5365c',fontSize:'15px',fontWeight:'bold'}}>Your answer</span> </>:null}*/}
                <div className={handleStyle()}>
                    <input
                        className="display-inp"
                        placeholder="Your Answer"
                        onChange={handleKeyboardValues}
                        value={
                            props.isPreview
                                ? props.data.question?.english_answer?.answer ||
                                  props.data.question?.hindi_answer?.answer
                                : value
                        }
                    />
                </div>
                <div className="keypad">
                    <div className="integers">
                        {d.map((data, i) => {
                            return (
                                <span
                                    className="button-values"
                                    onClick={() =>
                                        props.mock ? null : handleValue(data)
                                    }
                                >
                                    {data}
                                </span>
                            )
                        })}
                    </div>
                    <div className="util-buttons">
                        <span onClick={props.mock ? null : handleBackSpace}>
                            <img className="backspace-btn" src={backspace} />
                        </span>
                        <span onClick={() => (props.mock ? null : handleClear())}>
                            Clear All
                        </span>
                    </div>
                </div>
            </div>
            <span className="ans-description-mobile">Numerical</span>
            <input
                className="keyboardinp"
                placeholder="Round of answer to 2 decimal places"
                value={value}
                onChange={handleKeyboardValues}
            />
            {/*{*/}
            {/*    props.mock?*/}
            {/*        <>*/}
            {/*        <div style={{textAlign:'center',margin:'20px 0px',fontSize:'16px'}}>*/}
            {/*            {!(value==props.data.question.answers.answer)?<>*/}
            {/*                    <div style={{color:'#f5365c',fontWeight:'bold'}}>Your answer is incorrect!</div>*/}
            {/*                    <div style={{color:'#a1aeb7',fontWeight:500}}>Oops answer in a hurry?</div></>:*/}
            {/*                <><div style={{color:'#2dce89',fontWeight:'bold'}}>Your answer is correct!</div>*/}
            {/*                    <div style={{color:'#a1aeb7',fontWeight:500}}>Well done here is the solution</div>*/}
            {/*                </>*/}
            {/*            }*/}
            {/*        </div>*/}
            {/*        <div style={{border:'1px solid #00b0f5',justifyContent:'center',padding:'25px',borderRadius:'10px'}}>*/}
            {/*            <div style={{fontSize:'20px',fontWeight:'bold',color:'#00b0f5'}}>Solution</div>*/}
            {/*            <MathJax.Context*/}
            {/*                input='tex'*/}
            {/*                onLoad={ () => {}}*/}
            {/*                onError={ (MathJax, error) => {*/}
            {/*                    console.warn(error);*/}
            {/*                    console.log("Encountered a MathJax error, re-attempting a typeset!");*/}
            {/*                    MathJax.Hub.Queue(*/}
            {/*                        MathJax.Hub.Typeset()*/}
            {/*                    );*/}
            {/*                } }*/}
            {/*                options={ {*/}
            {/*                    messageStyle: 'none',*/}
            {/*                    extensions: ['tex2jax.js'],*/}
            {/*                    jax: ['input/TeX', 'output/HTML-CSS'],*/}
            {/*                    tex2jax: {*/}
            {/*                        inlineMath: [['$', '$'], ['\\(', '\\)']],*/}
            {/*                        displayMath: [['$$', '$$'], ['\\[', '\\]']],*/}
            {/*                        processEscapes: true,*/}
            {/*                    },*/}
            {/*                    TeX: {extensions: ["AMSmath.js","AMSsymbols.js","mhchem.js","noErrors.js","noUndefined.js"]},*/}
            {/*                } }*/}
            {/*            >*/}
            {/*                <MathJax.Html html={props.getAppendImgUrl(`<p>${props.data.question.solution}</p>`)}/>*/}
            {/*            </MathJax.Context>*/}
            {/*        </div></>*/}
            {/*        :null*/}
            {/*}*/}
        </div>
    )
}

export default NumericalTypeAnswer
